import { Link  } from "react-router-dom"; 
import { FcOrgUnit } from "react-icons/fc";
import { MdRequestQuote } from "react-icons/md";
import HandleCurrentPath from "./HandleCurrentPath"; 
import { FaGears, FaMoneyBillTrendUp  } from "react-icons/fa6";
import { TbReceiptTax  } from "react-icons/tb";
import { IoSendOutline } from "react-icons/io5";
import { AiOutlinePayCircle } from "react-icons/ai";
import { GiStakesFence,GiGlowingArtifact, GiClockwork } from "react-icons/gi";

// import { FiUsers } from "react-icons/fi";
const Menu = () =>{

  const pathname = window.location.pathname;
 
    return(
        <>
        <ul className="mt-6">
                <li className="relative px-6 py-3">
                 
                <HandleCurrentPath staticPath={'/'} currentPath={pathname} />
                <Link
                    className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    <FcOrgUnit />
                    <span className="ml-4">Dashboard</span>
                </Link>
                </li>
            </ul>

        <ul>

        
        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/prnRequest'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/prnRequest'} >
                <MdRequestQuote/>
                <span className="ml-4">PrnRequest </span>
            </Link>
        </li>

        <li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/paymentRequest'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/paymentRequest'} >
         <FaMoneyBillTrendUp/>
         <span className="ml-4">Payment Requests </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/taxpayoutresponse'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/taxpayoutresponse'} >
         <TbReceiptTax />
         <span className="ml-4">Tax payout response </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/stkPushRequest'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/stkPushRequest'} >
         <IoSendOutline/>
         <span className="ml-4">StkPushRequest </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/withdrawalRequest'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/withdrawalRequest'} >
         <AiOutlinePayCircle/>
         <span className="ml-4">WithdrawalRequest </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/receiveBulkStakes'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/receiveBulkStakes'} >
         <GiStakesFence/>
         <span className="ml-4">Stake Data </span>
     </Link>
</li>
<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/outcomeinfologs'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/outcomeinfologs'} >
         <GiGlowingArtifact/>
         <span className="ml-4">Bet Outcome Log </span>
     </Link>
</li>
            

        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/settings'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/settings'} >
                <FaGears/>
                <span className="ml-4">Settings</span>
            </Link>
        </li>

        <li className="relative px-6 py-3">
        <HandleCurrentPath staticPath={'/dailytaxobligation'} currentPath={pathname} />
        <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/dailytaxobligation'} >
            <GiClockwork/>
            <span className="ml-4">Daily Tax Obligation </span>
        </Link>
    </li>

  </ul>
        </>
    );
}
export default Menu;